import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=70db5772&scoped=true"
import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=70db5772&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db5772",
  null
  
)

export default component.exports